import { compose } from 'redux'
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';
import { configureStore, combineReducers, MiddlewareArray } from '@reduxjs/toolkit'
import thunk from 'redux-thunk'
import userReducer from './reducers/userReducer'
import UIReducer from './reducers/UIReducer'
import playerReducer from "./reducers/playerReducer";
const initialState = {};
const middleware = [thunk];

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION__?: typeof compose;
  }
}
const reducer = combineReducers({
  user: userReducer,
  UI: UIReducer,
  player: playerReducer,
});
const store = configureStore({
  reducer: reducer,
  middleware: new MiddlewareArray().concat(middleware),
  preloadedState: initialState
});
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export const UseAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default store;
